module.exports = __webpack_public_path__ + "static/media/mobile-4-1.3a4a131c.gif";